var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 51.5,
    fill: "white",
    stroke: "url(#paint0_linear_438_659)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_659",
    x1: 53,
    y1: 0,
    x2: 53,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A86B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6661FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.d1a6455ba7f93a63bd44219585866d4e.svg";
export { ForwardRef as ReactComponent };